import script from "./UserSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSearch.vue?vue&type=script&setup=true&lang=js"

import "./UserSearch.vue?vue&type=style&index=0&id=08fc98d2&lang=css"

const __exports__ = script;

export default __exports__